import type { Worker, WorkerRole } from "@utah-vr/shared";

export async function fetchWorkers(): Promise<{ workers: Worker[] }> {
	const res = await fetch("/api/workers");
	if (!res.ok) throw new Error(`workers fetch failed: ${res.status}`);
	return res.json();
}

export async function hireWorker(role: WorkerRole): Promise<{ ok?: true; worker?: Worker; error?: string }> {
	const res = await fetch("/api/workers/hire", {
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify({ role }),
	});
	return res.json();
}

export async function fireWorker(id: string): Promise<{ ok?: true; error?: string }> {
	const res = await fetch(`/api/workers/${encodeURIComponent(id)}/fire`, { method: "POST" });
	return res.json();
}
